import UserByStoreRepository from "../../../../repositories/userByStore";
import { userAuthActions } from "./slice";
import { toast } from "react-toastify";

const toastConfig = {
  position: "bottom-center",
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

const userRepo = new UserByStoreRepository();

export const setUserInfo = (data) => async (dispatch) => {
  dispatch(userAuthActions.setIsLoading(true));
  try {
    dispatch(userAuthActions.setUserManager(data));
  } catch (e) {
    toast.info(
      "Algo salió mal obteniendo tu información desde Mayca, intente nuevamente.",
      toastConfig
    );
  } finally {
    dispatch(userAuthActions.setIsLoading(false));
  }
};

export const setOfShowMFAModal = () => async (dispatch) => {
  dispatch(userAuthActions.setIsLoading(true));
  try {
    dispatch(userAuthActions.setShowMFAModal(false));
  } catch (e) {
    toast.info("Algo salió mal, intente nuevamente.", toastConfig);
  } finally {
    dispatch(userAuthActions.setIsLoading(false));
  }
};

export const setMyUserInfo = () => async (dispatch) => {
  dispatch(userAuthActions.setIsLoadingRole(true));
  try {
    const user = await userRepo.getMyInfoFromApi();
    dispatch(userAuthActions.setUserFromApi(user.data.result));
  } catch (e) {
    console.log(e);
  } finally {
    dispatch(userAuthActions.setIsLoadingRole(false));
  }
};

export const turnOffMFA = () => async (dispatch) => {
  try {
    await userRepo.dontAskMoreForMFA();
  } catch (e) {
    toast.info("Algo salió mal, intente nuevamente.", toastConfig);
  }
};
